// In your Redux slice file (e.g., filterSlice.js)
import { createSlice } from "@reduxjs/toolkit";
import { SearchFilterState } from "../types/searchFilterTypes";

export enum SearchType {
  UNITTYPE = "unittype",
  ILUCODE = "ilucode",
}

const initialState: SearchFilterState = {
  selectedSearchFilter: SearchType.UNITTYPE,
  searchArray: [],
  fromDate: null,
  toDate: null,
  fromTable: null,
};

export const filterSlice = createSlice({
  name: "filter",
  initialState: initialState,
  reducers: {
    setSearchFilter: (state, action) => {
      state.selectedSearchFilter = action.payload;
    },
    setSearchArray: (state, action) => {
      state.searchArray = action.payload;
    },
    setFromDate: (state, action) => {
      state.fromDate = action.payload;
    },
    setToDate: (state, action) => {
      state.toDate = action.payload;
    },
    setFromTable: (state, action) => {
      state.fromTable = action.payload;
    },
  },
});

export const {
  setToDate,
  setFromDate,
  setSearchFilter,
  setSearchArray,
  setFromTable,
} = filterSlice.actions;

export default filterSlice.reducer;
